import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Search, TrendingUp, Target, Users } from 'lucide-react';
const milestones = [{
  year: '2011',
  title: 'Primeros pasos en marketing digital',
  description: 'Lo que empezó como una simple curiosidad por aprender cómo generar ingresos por internet, rápidamente se convirtió en una pasión y un largo recorrido.',
  icon: Sparkles
}, {
  year: 'Exploración',
  title: 'SEO, CPA Marketing y Tráfico',
  description: 'Años de prueba y error explorando estrategias de tráfico orgánico, creación de contenido y diferentes modelos de negocios online.',
  icon: Search
}, {
  year: 'Evolución',
  title: 'Aprendiendo de los mejores',
  description: 'Estudiando a expertos reales del marketing y enfocándome más en la ejecución que en la teoría, desarrollando estrategias centradas en psicología digital.',
  icon: TrendingUp
}, {
  year: 'Enfoque',
  title: 'El poder de la afiliación',
  description: 'Descubrí que el marketing de afiliados ofrecía una de las mayores oportunidades para construir ingresos y libertad a largo plazo.',
  icon: Target
}, {
  year: 'Hoy',
  title: 'Ayudando a principiantes',
  description: 'Mi misión es simplificar el proceso para que personas comunes consigan sus primeras ventas online y desarrollen habilidades digitales reales.',
  icon: Users
}];
export function StoryTimeline() {
  return <section id="historia" className="py-24 md:py-32 relative" data-id="element-158">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-20" data-id="element-160">
          <span className="text-amber-400 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-161">
            La Historia
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-zinc-100" data-id="element-162">
            De la curiosidad a la maestría digital
          </h2>
        </motion.div>

        <div className="relative" data-id="element-163">
          {/* Vertical Line */}
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-amber-400/0 via-amber-400/20 to-amber-400/0 md:-translate-x-1/2" data-id="element-164" />

          <div className="space-y-12 md:space-y-24" data-id="element-165">
            {milestones.map((milestone, index) => {
            const isEven = index % 2 === 0;
            const Icon = milestone.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-0 ${isEven ? 'md:flex-row-reverse' : ''}`} data-id="element-166">
                  {/* Timeline Node */}
                  <div className="absolute left-0 md:left-1/2 w-14 h-14 rounded-full bg-[#0a0a0b] border border-amber-400/30 flex items-center justify-center md:-translate-x-1/2 shadow-[0_0_15px_rgba(251,191,36,0.1)] z-10" data-id="element-167">
                    <Icon className="w-6 h-6 text-amber-400" data-id="element-168" />
                  </div>

                  {/* Content Card */}
                  <div className={`w-full md:w-1/2 pl-20 md:pl-0 ${isEven ? 'md:pr-16 text-left md:text-right' : 'md:pl-16 text-left'}`} data-id="element-169">
                    <div className="bg-white/[0.02] backdrop-blur-sm border border-white/5 p-6 md:p-8 rounded-2xl hover:bg-white/[0.04] transition-colors group" data-id="element-170">
                      <span className="text-amber-400 font-mono text-sm mb-2 block" data-id="element-171">
                        {milestone.year}
                      </span>
                      <h3 className="text-xl font-bold text-zinc-100 mb-3 group-hover:text-amber-300 transition-colors" data-id="element-172">
                        {milestone.title}
                      </h3>
                      <p className="text-zinc-400 leading-relaxed text-sm md:text-base" data-id="element-173">
                        {milestone.description}
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}